import { render, staticRenderFns } from "./previewInstForm.vue?vue&type=template&id=0f948ac6&scoped=true&"
import script from "./previewInstForm.vue?vue&type=script&lang=js&"
export * from "./previewInstForm.vue?vue&type=script&lang=js&"
import style0 from "./previewInstForm.vue?vue&type=style&index=0&id=0f948ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f948ac6",
  null
  
)

export default component.exports